import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {TrnDischargelistComponent} from "./trn-dischargelist.component";

const routes: Routes = [
  {
    path: '', component: TrnDischargelistComponent
  }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/trn-dischargelist/trn-dischargelist.routing.ts